import React from 'react';
import { Col } from 'react-bootstrap';

export const ColumnSection = ({ title, text, contentTitle, contentText, right, icon }) => {
	const sectionDirection = right ? 'pull-right' : '';
	let sectionIcon = null;

	if (icon) {
		sectionIcon = <div className="icon"><span className={icon} /></div>;
	}

	return (
		<Col className={`content-column ${sectionDirection}`} lg={7} md={8} sm={12} xs={12}>
			<div className="inner">
				<div className="sec-title">
					<h4 className="subtitle">{text}</h4>
					<h2 dangerouslySetInnerHTML={{ __html: title }} />
				</div>

				<div className="content">
					{sectionIcon}
					<h3>{contentTitle}</h3>
					<div className="text">
						{contentText}
					</div>
				</div>
			</div>
		</Col>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/Section/ColumnSection.js